module.exports = __webpack_public_path__ + "img/gh-36020____-50.prt.d4cc6e21.jpg";